exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-star-rating {\n  display: block;\n}[dir=ltr] .vue-star-rating {\n  margin-right: auto;\n  margin-left: auto;\n}[dir=rtl] .vue-star-rating {\n  margin-left: auto;\n  margin-right: auto;\n}\n#shipping-detail .activity-desc {\n  text-transform: capitalize;\n}\n", ""]);

// exports
